import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalendarViewMonthIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calendar_view_month"}/>
}
